import { useSyncExternalStore } from "react";

export interface DesignPackageProgress {
  status: string;
  progressStatus: string | null;
  percent: number | null;
  designPackageItemId: number | null;
  at: string;
}

type Listener = () => void;

const progressById = new Map<number, DesignPackageProgress>();
const listeners = new Set<Listener>();

function notify() {
  listeners.forEach(listener => listener());
}

/** Transient per-package progress from cable messages, merged over query data for display only. */
export const designPackageProgressStore = {
  get(id: number): DesignPackageProgress | undefined {
    return progressById.get(id);
  },
  set(id: number, progress: DesignPackageProgress): void {
    progressById.set(id, progress);
    notify();
  },
  clear(id: number): void {
    if (progressById.delete(id)) notify();
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  /** Test-only reset. */
  reset(): void {
    progressById.clear();
    notify();
  },
};

export function useDesignPackageProgress(id: number | null): DesignPackageProgress | undefined {
  return useSyncExternalStore(
    designPackageProgressStore.subscribe,
    () => (id == null ? undefined : designPackageProgressStore.get(id)),
    () => undefined
  );
}
